import { URL } from "../../../../utils/routes";
import {
  FiHome,
  FiUsers,
  FiBriefcase,
  FiFolderPlus,
  FiSettings,
} from "react-icons/fi";
import { RiPulseLine } from "react-icons/ri";
import { DEFINED_PERMISSIONS } from "../../../../utils/const";
import { GetLocalStorage } from "../../../../utils/functions/GetLocalStorage";
import { USER_CATEGORY } from "../../../../utils/Enums";

export const sidebar = () => {
  const user = GetLocalStorage?.();
  const userPerm = JSON.parse(localStorage.getItem("x-u-perm"));
  const hrPerm = [
    DEFINED_PERMISSIONS.SeniorHRManager,
    DEFINED_PERMISSIONS.PrimaryHRManager,
    DEFINED_PERMISSIONS.HRManager,
    DEFINED_PERMISSIONS.SeniorAppraisalOfficer,
    DEFINED_PERMISSIONS.JuniorAppraisalOfficer,
  ];

  let matchedPermissionHr = "null";
  for (let i = 0; i < (userPerm?.length || 0); i++) {
    if (hrPerm.includes(userPerm[i])) {
      matchedPermissionHr = userPerm[i];
      break;
    }
  }

  const data = [
    {
      iconIMG: ({ top }) => (
        <FiHome size={"1.4rem"} style={{ marginTop: top }} />
      ),
      iconTag: "Dashboard",
      iconLink: "/dashboard",
      linkEnd: true,
      linkPermissions: [],
    },
    {
      iconIMG: ({ top }) => (
        <FiUsers size={"1.4rem"} style={{ marginTop: top }} />
      ),
      iconTag: `${
        USER_CATEGORY.VENDOR === user?.category ? "Vendor" : "Vendors"
      }`,
      iconLink: URL?.Vendors,
      linkEnd: true,
      linkPermissions: [
        DEFINED_PERMISSIONS.Vendor,
        DEFINED_PERMISSIONS.HOD,
        DEFINED_PERMISSIONS.SeniorAppraisalOfficer,
        DEFINED_PERMISSIONS.SeniorHRManager,
        DEFINED_PERMISSIONS.EDFinanceApprove,
        DEFINED_PERMISSIONS.EDOperationApprove,
        DEFINED_PERMISSIONS.MDApprove,
      ],
      hasSubLinks: false,
    },
    {
      iconIMG: ({ top }) => (
        <FiFolderPlus size={"1.4rem"} style={{ marginTop: top }} />
      ),
      iconTag: "Finance & Admin",
      iconLink: "#",
      linkEnd: false,
      linkPermissions: [
        DEFINED_PERMISSIONS.ViewAdminAndFinanceModule,
        DEFINED_PERMISSIONS.Vendor,
      ],
      hasSubLinks1: true,
      subLinks1: [
        {
          sublink: "Employee Management",
          subUrl: URL?.EmployeeService,
          linkPermissions: [
            DEFINED_PERMISSIONS.SeniorProcurementManager,
            DEFINED_PERMISSIONS.PrimaryProcurementManager,
          ],
          hasSubLinks2: true,
          subLinks2: [
            {
              sublink: "Weekend Allowance",
              subUrl: URL.EmployeeService + "/" + URL.Weekend_Allowance_Hod,
              linkPermissions: [
                DEFINED_PERMISSIONS.WeekendAllowance,
                DEFINED_PERMISSIONS.WeekendAllowanceHOD,
                DEFINED_PERMISSIONS.ApproveWeekendAllowanceEDOps,
                DEFINED_PERMISSIONS.ApproveWeekendAllowanceEDOFI,
                DEFINED_PERMISSIONS.ApproveWeekendAllowanceMD,
              ],
            },
            {
              sublink: "Medical Requisition",
              subUrl: URL?.EmployeeService + "/" + URL.Extended_HMO_Claims,
              linkPermissions: [
                DEFINED_PERMISSIONS.HMOClaims,
                DEFINED_PERMISSIONS.HMOClaimsHOD,
                DEFINED_PERMISSIONS.ApproveHMOClaimsEDOps,
                DEFINED_PERMISSIONS.ApproveHMOClaimsEDOFI,
                DEFINED_PERMISSIONS.ApproveHMOClaimsMD,
              ],
            },
            {
              sublink: "Payment Requisiton",
              subUrl: URL?.EmployeeService + "/" + URL?.Payment_Requisition,
              linkPermissions: [
                DEFINED_PERMISSIONS.EmployeePaymentRequisition,
                DEFINED_PERMISSIONS.EmployeePaymentRequisitionHOD,
                DEFINED_PERMISSIONS.ApproveEmployeePaymentRequisitionEDOps,
                DEFINED_PERMISSIONS.ApproveEmployeePaymentRequisitionEDOFI,
                DEFINED_PERMISSIONS.ApproveEmployeePaymentRequisitionMD,
              ],
            },
            {
              sublink: "Overtime Management",
              subUrl: URL?.EmployeeService + "/" + URL?.Overtime_Management,
              linkPermissions: [],
            },
          ],
        },
        {
          sublink: "Procurement",
          subUrl: URL?.Procurement,
          linkPermissions: [
            DEFINED_PERMISSIONS.SeniorProcurementManager,
            DEFINED_PERMISSIONS.PrimaryProcurementManager,
            DEFINED_PERMISSIONS.Vendor,
          ],
          hasSubLinks2: true,
          subLinks2: [
            {
              sublink: "Requisition",
              subUrl: URL?.Procurement + "/" + URL?.Requisition_Management,
              linkPermissions: [],
            },
            {
              sublink: "Waiver Approval",
              subUrl: URL?.Procurement + "/" + URL.Waiver_Management,
              linkPermissions: [DEFINED_PERMISSIONS.BudgetWaiver],
            },
            {
              sublink: "Quotation",
              subUrl: URL?.Procurement + "/" + URL?.Quotation_Management,
              linkPermissions: [],
            },
            {
              sublink: "Delivery",
              subUrl: URL?.Procurement + "/" + URL?.Delivery,
              linkPermissions: [
                DEFINED_PERMISSIONS.SeniorProcurementManager,
                DEFINED_PERMISSIONS.PrimaryProcurementManager,
              ],
            },
            {
              sublink: "Maintenance",
              subUrl: URL?.Procurement + "/" + URL?.Maintenance,
              linkPermissions: [
                DEFINED_PERMISSIONS.SeniorProcurementManager,
                DEFINED_PERMISSIONS.PrimaryProcurementManager,
                DEFINED_PERMISSIONS.AssetView,
              ],
            },

            {
              sublink: "Vendor Payment",
              subUrl: URL?.Procurement + "/" + URL?.vendorPayment,
              linkPermissions: [DEFINED_PERMISSIONS.VendorPayment],
            },
          ],
        },
        {
          iconIMG: (rest) => <FiBriefcase size={"1.4rem"} {...rest} />,
          sublink: "Finance",
          subUrl: URL.finance,
          linkEnd: false,
          linkPermissions: [
            DEFINED_PERMISSIONS.HODFinance,
            DEFINED_PERMISSIONS.FinanceOfficer,
            DEFINED_PERMISSIONS.SeniorFinanceOfficer,
          ],
          hasSubLinks2: true,
          subLinks2: [
            {
              sublink: "Payroll",
              subUrl: URL.finance + "/" + URL.PayrollAutorun,
              linkPermissions: [],
            },
            {
              sublink: "Payment",
              subUrl: URL.finance + "/" + URL.Payment,
              linkPermissions: [DEFINED_PERMISSIONS.CostCenterStakeholder],
            },
            {
              sublink: "Payment Service",
              subUrl: URL.finance + "/" + URL.PaymentService,
              linkPermissions: [DEFINED_PERMISSIONS.CostCenterStakeholder],
            },
            {
              sublink: "Setup A Service",
              subUrl: URL.finance + "/" + URL.SetupAService,
              linkPermissions: [],
            },
            {
              sublink: "Account Setup",
              subUrl: URL.finance + "/" + URL.AccountSetup,
              linkPermissions: [],
            },
            {
              sublink: "Exchange Rate Setup",
              subUrl: URL.finance + "/" + URL.ExchangeRateSetup,
              linkPermissions: [],
            },
            {
              sublink: "Book A Service",
              subUrl: URL.finance + "/" + URL.BookAService,
              linkPermissions: [],
            },
            {
              sublink: "Manage Booking Request",
              subUrl: URL.finance + "/" + URL.ManageBookingRequest,
              linkPermissions: [],
            },
            {
              sublink: "Cost Centre Expenses",
              subUrl: URL.finance + "/" + URL.CostCenterExpenses,
              linkPermissions: [DEFINED_PERMISSIONS.CostCenterStakeholder],
            },
            {
              sublink: "Asset Depreciation & NBV",
              subUrl: URL.finance + "/" + URL.AssetNBV,
              linkPermissions: [DEFINED_PERMISSIONS.CostCenterStakeholder],
            },
            {
              sublink: "Company Fund",
              subUrl: URL.finance + "/" + URL.CompanyFund,
              linkPermissions: [DEFINED_PERMISSIONS.CostCenterStakeholder],
            },
            {
              sublink: "Accounting Ledger (Setup)",
              subUrl: URL.finance + "/" + URL.AccountingLedgerSetup,
              linkPermissions: [DEFINED_PERMISSIONS.CostCenterStakeholder],
            },
            {
              sublink: "Accounting Ledger",
              subUrl: URL.finance + "/" + URL.AccountingLedger,
              linkPermissions: [DEFINED_PERMISSIONS.CostCenterStakeholder],
            },
            {
              sublink: "Budget Import",
              subUrl: URL.finance + "/" + URL.BudgetImport,
              linkPermissions: [],
            },
            {
              sublink: "Cooperative Setup",
              subUrl: URL.finance + "/" + URL.CooperativeComponent,
              linkPermissions: [],
            },
            {
              sublink: "Cooperative Management",
              subUrl: URL.finance + "/" + URL.CooperativeManagement,
              linkPermissions: [],
            },
            {
              sublink: "Non-statutory Advice Management",
              subUrl: `${URL.finance}/${URL.NonStatutoryAdviceManagement}`,
              linkPermissions: [],
            },
            {
              sublink: "Credit Facility",
              subUrl: URL.finance + "/" + URL.CreditFacility,
              linkPermissions: [],
            },
            {
              sublink: "Feedback Survey",
              subUrl: URL.finance + "/" + URL.Feedback_Survey,
              linkPermissions: [DEFINED_PERMISSIONS.FinanceOfficer, DEFINED_PERMISSIONS.SeniorFinanceOfficer],
            },
            
          ],
        },
        {
          sublink: "Assets Management",
          subUrl: URL?.Assets,
          linkPermissions: [DEFINED_PERMISSIONS.AssetView],
          hasSubLinks2: true,
          subLinks2: [
            {
              sublink: "Asset Acquisition",
              subUrl: URL?.Assets + "/" + URL?.Acquisition,
              linkPermissions: DEFINED_PERMISSIONS.AssetAcquisitionView,
            },
            {
              sublink: "Asset Requisition",
              subUrl: URL?.Assets + "/" + URL?.Requisition,
              linkPermissions: DEFINED_PERMISSIONS.AssetRequisitionView,
            },
            {
              sublink: "Asset Allocation",
              subUrl: URL?.Assets + "/" + URL?.Allocation,
              linkPermissions: DEFINED_PERMISSIONS.AssetAllocationView,
            },
            {
              sublink: "Asset Monitoring",
              subUrl: URL?.Assets + "/" + URL?.Monitoring,
              linkPermissions: DEFINED_PERMISSIONS.AssetRequisitionView,
            },
            {
              sublink: "Asset Auctioning",
              subUrl: URL?.Assets + "/" + URL?.Auctioning,
              linkPermissions: DEFINED_PERMISSIONS.AssetAuctionView,
            },
            {
              sublink: "Auctioning (Bidding)",
              subUrl: URL?.Assets + "/" + URL?.AuctionBidding,
              linkPermissions: DEFINED_PERMISSIONS.AssetBidView,
            },
          ],
        },
        {
          sublink: "Consumable Mgt",
          subUrl: URL?.Consumables,
          linkPermissions: DEFINED_PERMISSIONS.ConsumableView,
          hasSubLinks2: true,
          subLinks2: [
            {
              sublink: "Acquisition",
              subUrl: URL?.Consumables + "/" + URL?.Consumable_Acqusition,
              linkPermissions: DEFINED_PERMISSIONS.ConsumableView,
            },
            {
              sublink: "Requisition",
              subUrl: URL?.Consumables + "/" + URL?.Consumable_Requsition,
              linkPermissions: DEFINED_PERMISSIONS.ConsumableRequisitionView,
            },
            {
              sublink: "Allocation",
              subUrl: URL?.Consumables + "/" + URL?.Consumable_Allocation,
              linkPermissions: DEFINED_PERMISSIONS.ConsumableAllocationView,
            },
          ],
        },
        {
          sublink: "Asset Setup",
          subUrl: URL?.AssetSetUp,
          linkPermissions: DEFINED_PERMISSIONS.AssetView,
          hasSubLinks2: true,
          subLinks2: [
            {
              sublink: "Asset Register",
              subUrl: URL?.AssetSetUp + "/" + URL?.AssetRegister,
              linkPermissions: DEFINED_PERMISSIONS.AssetView,
            },
            {
              sublink: "Category",
              subUrl: URL?.AssetSetUp + "/" + URL?.Categories,
              linkPermissions: DEFINED_PERMISSIONS.AssetCategoryView,
            },
          ],
        },
        {
          sublink: "Store & Inventory Setup",
          subUrl: URL?.ConsummableSetUp,
          linkPermissions: DEFINED_PERMISSIONS.ConsumableView,
          hasSubLinks2: true,
          subLinks2: [
            {
              sublink: "Consumable Register",
              subUrl: URL?.ConsummableSetUp + "/" + URL?.ConsummbaleRegister,
              linkPermissions: DEFINED_PERMISSIONS.ConsumableView,
            },
            {
              sublink: "Categories",
              subUrl: URL?.ConsummableSetUp + "/" + URL?.ConsummableCategories,
              linkPermissions: DEFINED_PERMISSIONS?.ConsumableCategoryView,
            },
          ],
        },
      ],
    },
    {
      iconIMG: (rest) => <FiBriefcase size={"1.4rem"} {...rest} />,
      iconTag: "Management",
      iconLink: "#",
      linkEnd: false,
      linkPermissions: [
        DEFINED_PERMISSIONS.HOD,
        DEFINED_PERMISSIONS.SeniorAppraisalOfficer,
        DEFINED_PERMISSIONS.SeniorHRManager,
        DEFINED_PERMISSIONS.EDFinanceApprove,
        DEFINED_PERMISSIONS.EDOperationApprove,
        DEFINED_PERMISSIONS.MDApprove,
      ],
      hasSubLinks: true,
      subLinks: [
        {
          sublink: `Vendors`,
          subUrl: URL?.Management + "/" + URL?.Vendors,
          linkPermissions: [],
        },
        {
          sublink: "Memo Writing",
          subUrl: URL?.Management + "/" + URL?.Memo_Requisition,
          linkPermissions: [],
        },
        {
          sublink: "Procurement Requisition",
          subUrl: URL?.Procurement + "/" + URL?.Requisition_Management,
          linkPermissions: [],
        },
        {
          sublink: "Payment Requisition",
          subUrl: URL.Management + "/" + URL.Payment_Requisition,
          linkPermissions: [DEFINED_PERMISSIONS.HOD],
        },
        {
          sublink: "Quotation",
          subUrl: URL?.Procurement + "/" + URL?.Quotation_Management,
          linkPermissions: [],
        },
        {
          sublink: "Leave Approval (HOD)",
          subUrl: URL.Management + "/" + URL.Leave_HOD,
          linkPermissions: [DEFINED_PERMISSIONS.HOD],
        },
        {
          sublink: "Weekend Allowance HOD",
          subUrl:
            URL.Management +
            "/" +
            URL.Weekend_Allowance +
            "/" +
            URL.Weekend_Allowance_Hod,
          linkPermissions: DEFINED_PERMISSIONS.HOD,
        },
        {
          sublink: "Exit Requisition HOD",
          subUrl: URL?.Management + "/" + URL?.Exit_HOD,
          linkPermissions: DEFINED_PERMISSIONS.HOD,
        },
        {
          sublink: "Overtime HOD",
          subUrl: URL?.Management + "/" + URL?.Overtime_Management,
          linkPermissions: DEFINED_PERMISSIONS.HOD,
        },
        {
          sublink: "Appraisal Review (HOD)",
          subUrl: URL?.Management + "/" + URL?.MANAGEMENT_APPRAISAL,
          linkPermissions: [
            DEFINED_PERMISSIONS.HOD,
            DEFINED_PERMISSIONS.SeniorAppraisalOfficer,
          ],
        },
        {
          sublink: "Appraisal Review",
          subUrl: URL?.Management + "/" + URL?.APPRAISAL_REVIEW_MGT,
          linkPermissions: [
            DEFINED_PERMISSIONS.EDFinanceApprove,
            DEFINED_PERMISSIONS.EDOperationApprove,
            DEFINED_PERMISSIONS.MDApprove,
          ],
        },
        {
          sublink: "Float Request (MGT)",
          subUrl: URL?.Management + "/" + URL?.ManagementFloatRequest,
          linkPermissions: [
            DEFINED_PERMISSIONS.FLoatApprove0,
            DEFINED_PERMISSIONS.EDFinanceApprove,
            DEFINED_PERMISSIONS.MDApprove,
            DEFINED_PERMISSIONS.EDOperationApprove,
          ],
        },
      ],
    },
    {
      iconIMG: (rest) => <FiBriefcase size={"1.4rem"} {...rest} />,
      iconTag: "Control Review",
      iconLink: URL.ControlReview,
      linkEnd: false,
      hasSubLinks: true,
      linkPermissions: [
        DEFINED_PERMISSIONS.HOD,
        DEFINED_PERMISSIONS.SeniorAppraisalOfficer,
        DEFINED_PERMISSIONS.SeniorHRManager,
        DEFINED_PERMISSIONS.EDFinanceApprove,
        DEFINED_PERMISSIONS.EDOperationApprove,
        DEFINED_PERMISSIONS.MDApprove,
      ],
      subLinks: [
        {
          sublink: "Employee Payment Requisition",
          subUrl: `${URL.ControlReview}/${URL.Payment_Requisition}`,
          linkPermissions: [DEFINED_PERMISSIONS.HOD],
        },
        {
          sublink: "Weekend Allowance",
          subUrl: `${URL.ControlReview}/${URL.Weekend_Allowance}`,
          linkPermissions: DEFINED_PERMISSIONS.HOD,
        },
        // {
        //   sublink: "Overtime",
        //   subUrl: `${URL.ControlReview}/${URL.Overtime_Management}`,
        //   linkPermissions: DEFINED_PERMISSIONS.HOD,
        // },
        {
          sublink: "Quotation",
          subUrl: `${URL.ControlReview}/${URL.Quotation_Management}`,
          linkPermissions: DEFINED_PERMISSIONS.HOD,
        },
      ],
    },
    {
      iconIMG: (rest) => <FiBriefcase size={"1.4rem"} {...rest} />,
      iconTag: "Fleet Management",
      iconLink: URL?.Fleets,
      linkEnd: false,
      linkPermissions: [
        DEFINED_PERMISSIONS.PrimaryFleetManager,
        DEFINED_PERMISSIONS.SecondaryFleetManager,
      ],
      hasSubLinks: true,
      subLinks: [
        {
          sublink: "Fleets",
          subUrl: URL?.Fleets + "/" + URL?.Fleet_Management,
          linkPermissions: [],
        },
        {
          sublink: "Fuel Requisition",
          subUrl: URL?.Fleets + "/" + URL?.Requisition,
          linkPermissions: [],
        },
        {
          sublink: "Fuel Payment",
          subUrl: URL?.Fleets + "/" + URL?.Fuel_Payment,
          linkPermissions: [],
        },
        {
          sublink: "Driver Activity",
          subUrl: URL?.Fleets + "/" + URL?.Driver_Activity,
          linkPermissions: [],
        },
        {
          sublink: "All Driver Activity",
          subUrl:
            URL?.Fleets +
            "/" +
            URL?.Driver_Activity +
            "/" +
            URL.All_DriverActivity,
          linkPermissions: [DEFINED_PERMISSIONS.DriverActivityAdmin],
        },
        {
          sublink: "Accident Report",
          subUrl: URL?.Fleets + "/" + URL?.Accident_Report,
          linkPermissions: [],
        },
        {
          sublink: "Generate Report",
          subUrl: URL?.Fleets + "/" + URL?.Generate_Report,
          linkPermissions: [],
        },
        {
          sublink: "Document Set-Up",
          subUrl: URL?.Fleets + "/" + URL?.Vehicle_Document_SetUp,
          linkPermissions: [],
        },
        {
          sublink: "Tracker",
          subUrl: URL?.Fleets + "/" + URL?.Movement,
          linkPermissions: [],
        },
      ],
    },
    {
      iconIMG: (rest) => <FiBriefcase size={"1.4rem"} {...rest} />,
      iconTag: "HR Services",
      iconLink: URL?.HR,
      linkEnd: false,
      linkPermissions: matchedPermissionHr || [],
      hasSubLinks: true,
      subLinks: [
        {
          sublink: "Employee Management",
          subUrl: URL.HR + "/" + URL.Employee_Management,
          linkPermissions: [
            DEFINED_PERMISSIONS.SeniorHRManager,
            DEFINED_PERMISSIONS.PrimaryHRManager,
            DEFINED_PERMISSIONS.HRManager,
          ],
        },
        {
          sublink: "Add Employee",
          subUrl: `${URL?.Employee}/${URL?.My_Employee_Info}/add`,
          linkPermissions: [
            // DEFINED_PERMISSIONS.SeniorHRManager,
            // DEFINED_PERMISSIONS.PrimaryHRManager,
            // DEFINED_PERMISSIONS.HRManager,
          ],
        },
        {
          sublink: "Leave Approval (HR)",
          subUrl: URL.HR + "/" + URL.Leave_Approval,
          linkPermissions: [
            DEFINED_PERMISSIONS.SeniorHRManager,
            DEFINED_PERMISSIONS.PrimaryHRManager,
          ],
        },

        {
          sublink: "Leave Setup",
          subUrl: URL.HR + "/" + URL.Leave_SetUp,
          linkPermissions: [
            DEFINED_PERMISSIONS.SeniorHRManager,
            DEFINED_PERMISSIONS.PrimaryHRManager,
          ],
        },
        {
          sublink: "Training",
          subUrl: URL?.HR + "/" + URL?.Training_Request,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Training Setup",
          subUrl: URL?.HR + "/" + URL?.Training_SetUp,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Exit Management",
          subUrl: URL?.HR + "/" + URL?.Exit_Management,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Exit Discussion Setup",
          subUrl: URL?.HR + "/" + URL?.Exit_Discussion_SetUp,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Overtime Setup",
          subUrl: URL?.HR + "/" + URL?.Overtime_Setup,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Overtime Management",
          subUrl: URL?.HR + "/" + URL?.Overtime_Management,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Query Setup",
          subUrl: URL?.HR + "/" + URL?.Query_SetUp,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Query Management",
          subUrl: URL?.HR + "/" + URL?.Query_Management,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Payroll Set-up",
          subUrl: URL?.HR + "/" + URL?.Payroll_Setup,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Payroll Structure",
          subUrl: URL.HR + "/" + URL.Payroll_Structure,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Weekend Allowance Setup",
          subUrl: URL.HR + "/" + URL.Weekend_Allowance_Setup,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Auxiliary Service Setup",
          subUrl: URL.HR + "/" + URL.Auxiliary_Service_Setup,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Auxiliary Service Approval",
          subUrl: URL.HR + "/" + URL.Auxiliary_Service_Approval,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Repayment Plan setup",
          subUrl: URL.HR + "/" + URL.Repayment_Plan_Setup,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Query Request",
          subUrl: URL.HR + "/" + URL.query_request,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Query Approval",
          subUrl: `${URL.HR}/${URL.query_approval}?approval=control`,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Attendance & Clock(Setup)",
          subUrl: URL?.HR + "/" + URL?.Attendance_Clock,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "All Query ",
          subUrl:
            URL?.HR +
            "/" +
            URL.Query_Management +
            "/" +
            URL?.All_Query_Management,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Medical Service Setup",
          subUrl: URL.HR + "/" + URL.Medical,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Recruitment (Setup)",
          subUrl: URL.HR + "/" + URL.Recruitment_Setup,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Recruitment Services",
          subUrl: URL.HR + "/recruitment-service/" + URL.Recruitment_Process,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Employee Group",
          subUrl: URL.HR + "/" + URL.Employee_Group,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Employee Cadre Position",
          subUrl: URL.HR + "/" + URL.Employee_Cadre_Position,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Employee All Level",
          subUrl: URL.HR + "/" + URL.Employee_Cadre_Position_Level,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Directorate",
          subUrl: URL.HR + "/" + URL.Directorate,
          linkPermissions: [DEFINED_PERMISSIONS.Group],
        },
        {
          sublink: "Appraisal (HR)",
          subUrl: URL.HR + "/" + URL.Appraisal_HR,
          linkPermissions: [
            DEFINED_PERMISSIONS.SeniorHRManager,
            DEFINED_PERMISSIONS.PrimaryHRManager,
            DEFINED_PERMISSIONS.HRManager,
            DEFINED_PERMISSIONS.HOD,
            DEFINED_PERMISSIONS.JuniorAppraisalOfficer,
            DEFINED_PERMISSIONS.SeniorAppraisalOfficer,
          ],
        },
        {
          sublink: "Appraisal Setup",
          subUrl: URL.HR + "/" + URL.Appraisal_Setup,
          linkPermissions: [
            DEFINED_PERMISSIONS.SeniorHRManager,
            DEFINED_PERMISSIONS.PrimaryHRManager,
            DEFINED_PERMISSIONS.HRManager,
            DEFINED_PERMISSIONS.HOD,
            DEFINED_PERMISSIONS.JuniorAppraisalOfficer,
            DEFINED_PERMISSIONS.SeniorAppraisalOfficer,
          ],
        },
      ],
    },
    {
      iconIMG: (rest) => <FiUsers size={"1.4rem"} {...rest} />,
      iconTag: "Employee Services",
      iconLink: URL?.Employee,
      linkEnd: false,
      linkPermissions: DEFINED_PERMISSIONS.Staff,
      hasSubLinks: true,
      subLinks: [
        {
          sublink: "Employee",
          subUrl: URL?.Employee + "/" + URL?.My_Employee_Info,
          linkPermissions: [],
        },
        {
          sublink: `Vendors`,
          subUrl: URL?.Employee + "/" + URL?.Vendors,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "Training",
          subUrl: URL?.Employee + "/" + URL?.Training,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "Leave Request",
          subUrl: URL.Employee + "/" + URL.Leave_Requisition,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "Exit Requisition",
          subUrl: URL?.Employee + "/" + URL?.Exit_Requisition,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "My Query",
          subUrl: URL?.Employee + "/" + URL?.My_Query,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "Payroll Service",
          subUrl: URL?.Employee + "/" + URL?.Payroll,
          linkPermissions: DEFINED_PERMISSIONS.Group,
        },
        {
          sublink: "Procurement Requisition",
          subUrl: URL?.Employee + "/" + URL?.Procurement,
          linkPermissions: DEFINED_PERMISSIONS.Group,
        },

        {
          sublink: "Query HOC",
          subUrl: URL?.Employee + "/" + URL?.Query_By_HOC,
          linkPermissions: DEFINED_PERMISSIONS.Group,
        },
        {
          sublink: "Overtime Requisition",
          subUrl: URL?.Employee + "/" + URL?.Overtime_Requisition,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "Employee Medical Requisition",
          subUrl: URL.Employee + "/" + URL.Employee_Medical_Requisition,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "Extended HMO Claims",
          subUrl: URL.Employee + "/" + URL.Extended_HMO_Claims,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "Employee Payment Requisition",
          subUrl: URL.Employee + "/" + URL.Payment_Requisition,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "Weekend Allowance",
          subUrl: URL.Employee + "/" + URL.Weekend_Allowance,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "Memo Writing",
          subUrl: URL.Employee + "/" + URL.Memo_Requisition,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "Auxiliary Service Request",
          subUrl: URL.Employee + "/" + URL.Auxiliary_Service_Request,
          linkPermissions: DEFINED_PERMISSIONS.Group,
        },
        {
          sublink: "Auctioning Bidding",
          subUrl: URL.Employee + "/" + URL.AuctionBidding,
          linkPermissions: DEFINED_PERMISSIONS.Group,
        },
        {
          sublink: "Self Appraisal",
          subUrl: URL.Employee + "/" + URL.Self_Appraisal,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "Line Manager Processes",
          subUrl: URL.Employee + "/" + URL.Line_Manager_Appraisal,
          linkPermissions: [DEFINED_PERMISSIONS.LineManager],
        },
        {
          sublink: "Appraisal 360 Review",
          subUrl: URL.Employee + "/" + URL.PerfomanceAppraisal,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "Employee PIP",
          subUrl: URL.Employee + "/" + URL.Employee_PIP,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "Float Request",
          subUrl: URL.Employee + "/" + URL.Employee_Float_Request,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
        {
          sublink: "Control Review - Float Request",
          subUrl: URL.Employee + "/" + URL.Control_Review_Float_Request,
          linkPermissions: [DEFINED_PERMISSIONS.InternalControl],
        },
        {
          sublink: "Quotation (Employee)",
          subUrl: URL.Employee + "/" + URL.Employee_Quotation,
          linkPermissions: [DEFINED_PERMISSIONS.Staff],
        },
      ],
    },
    {
      iconIMG: (rest) => <RiPulseLine size={"1.4rem"} {...rest} />,
      iconTag: "Reports",
      iconLink: URL?.Reports,
      linkEnd: true,
      linkPermissions: DEFINED_PERMISSIONS.Report,
      hasSubLinks: true,
      subLinks: [
        {
          sublink: "Report Configuration",
          subUrl: URL?.Reports + "/" + URL?.Report_configuration,
          exact: true,
          linkPermissions: DEFINED_PERMISSIONS.ReportAdd,
        },
        {
          sublink: "Trigger History",
          subUrl: URL?.Reports + "/" + URL?.Trigger_History,
          linkPermissions: DEFINED_PERMISSIONS.ReportTrigger,
        },
        {
          sublink: "Generate Report",
          subUrl: URL?.Reports + "/" + URL.Generate_Report,
          exact: true,
          linkPermissions: [],
        },
      ],
    },
    {
      iconIMG: (rest) => <FiSettings size={"1.4rem"} {...rest} />,
      iconTag: "Settings",
      iconLink: URL?.Settings,
      linkEnd: true,
      linkPermissions: DEFINED_PERMISSIONS.PermissionManager,
      hasSubLinks: true,
      subLinks: [
        {
          sublink: "User Access Setup",
          subUrl: URL?.Settings + "/" + URL?.Permissions,
          linkPermissions: DEFINED_PERMISSIONS.PermissionManager,
        },
        {
          sublink: "Permission Groups",
          subUrl: URL?.Settings + "/" + URL?.Permission_Group,
          linkPermissions: DEFINED_PERMISSIONS.PermissionManager,
        },
      ],
    },
  ];

  return data;
};
